<div [id]="'div-' + description" class="canvas-container">
  <!-- <canvas [id]="'canvas-' + description"></canvas> -->
  <canvas #canvas id="canvas-{{ description }}" style="height: 130px;"></canvas>
</div>
